import { useEffect, useMemo, useState } from "react";

export type City = string;

// TODO: created an API endpoint for this (GET /api/hardcodedCities), remove hardcoded cities
const useHardcodedCities = () => {
  const [cities, setCities] = useState<City[]>([]);

  const hardcodedCities = [
    "Akmenės r.",
    "Alytaus m.",
    "Alytaus r.",
    "Anykščių r.",
    "Birštono sav.",
    "Biržų r.",
    "Druskininkų sav.",
    "Elektrėnų sav.",
    "Ignalinos r.",
    "Jonavos r.",
    "Joniškio r.",
    "Jurbarko r.",
    "Kaišiadorių r.",
    "Kalvarijos sav.",
    "Kauno m.",
    "Kauno r.",
    "Kazlų Rūdos sav.",
    "Kėdainių r.",
    "Kelmės r.",
    "Klaipėdos m.",
    "Klaipėdos r.",
    "Kretingos r.",
    "Kupiškio r.",
    "Lazdijų r.",
    "Marijampolės sav.",
    "Mažeikių r.",
    "Molėtų r.",
    "Neringos sav.",
    "Pagėgių sav.",
    "Pakruojo r.",
    "Palangos m.",
    "Panevėžio m.",
    "Panevėžio r.",
    "Pasvalio r.",
    "Plungės r.",
    "Prienų r.",
    "Radviliškio r.",
    "Raseinių r.",
    "Rietavo sav.",
    "Rokiškio r.",
    "Skuodo r.",
    "Šakių r.",
    "Šalčininkų r.",
    "Šiaulių m.",
    "Šiaulių r.",
    "Šilalės r.",
    "Šilutės r.",
    "Širvintų r.",
    "Švenčionių r.",
    "Tauragės r.",
    "Telšių r.",
    "Trakų r.",
    "Ukmergės r.",
    "Utenos r.",
    "Varėnos r.",
    "Vilkaviškio r.",
    "Vilniaus m.",
    "Vilniaus r.",
    "Visagino sav.",
    "Zarasų r.",
    "Kita",
  ];

  useEffect(() => {
    setCities(hardcodedCities);
  }, []);

  return useMemo(
    () => ({
      cities,
      cityOptions: cities.map((city) => ({ key: city, value: city, text: city })),
    }),
    [cities]
  );
};

export default useHardcodedCities;
